// extracted by mini-css-extract-plugin
module.exports = {"construction":"styles_construction__3f_CF","indicator":"styles_indicator__3PIhF"};